(function(window, document, $) {
  'use strict';

  if (!$) {
    return;
  }

  function parseProduct(node) {
    try {
      return JSON.parse(node.getAttribute('data-product-json') || '{}');
    } catch (error) {
      return {};
    }
  }

  function displayCents(cents) {
    return Math.round(cents);
  }

  function schemaPrice(cents) {
    return (displayCents(cents) / 100).toFixed(2);
  }

  function initQuantityButtons() {
    if (window.ThemeQuantity && typeof window.ThemeQuantity.bindLegacySteppers === 'function') {
      window.ThemeQuantity.bindLegacySteppers();
    }
  }

  function initProductOptions(node) {
    var product = parseProduct(node);
    var productId = node.getAttribute('data-product-id');
    var showSku = node.getAttribute('data-show-sku') === 'true';
    var moneyFormat = node.getAttribute('data-money-format') || '';
    var addToCartText = node.getAttribute('data-add-to-cart-text') || 'Add To Cart';
    var soldOutText = node.getAttribute('data-sold-out-text') || 'Sold Out';
    var unavailableText = node.getAttribute('data-unavailable-text') || 'Unavailable';
    var availableText = node.getAttribute('data-available-text') || 'available';
    var singleOptionLabel = node.getAttribute('data-single-option-label') || '';
    var hideDefaultSelector = node.getAttribute('data-hide-default-selector') === 'true';

    if (!productId || !window.Shopify || !window.Shopify.OptionSelectors) {
      return;
    }

    function displayMoney(cents) {
      return window.Shopify.formatMoney(displayCents(cents), moneyFormat);
    }

    function refreshCurrencies() {
      if (node.getAttribute('data-show-multiple-currencies') === 'true' && window.currenciesCallbackSpecial) {
        window.currenciesCallbackSpecial('#product-info span.money');
      }
    }

    function buildPriceElement(tagName, className, html) {
      // Shopify money formatting can include span.money markup, so only price fragments use HTML.
      return $('<' + tagName + '>').addClass(className).html(html);
    }

    // Search: product-page-price-refresh - one path renders variant price, compare-at price, and savings.
    function updateProductPrice(target, variant, unavailableLabel) {
      var $price = $(target).empty();
      var savings;

      if (!variant || !variant.available) {
        $price.append(buildPriceElement('span', 'unavailable', unavailableLabel));
        return;
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        savings = variant.compare_at_price - variant.price;
        $price
          .append(buildPriceElement('span', 'price-sale', displayMoney(variant.price)))
          .append(buildPriceElement('del', 'price-compare', displayMoney(variant.compare_at_price)))
          .append(buildPriceElement('span', 'product-page-savings', 'Save ' + displayMoney(savings)));
        return;
      }

      $price.append(buildPriceElement('span', 'price', displayMoney(variant.price)));
    }

    function selectOptionsCallback(variant, selector) {
      var addToCart = '#add-to-cart';
      var price = '#purchase-' + selector.product.id.toString() + ' .detail-price';
      var priceMeta = '#product-price-meta-' + selector.product.id.toString();
      var availabilityMeta = '#product-availability-meta-' + selector.product.id.toString();
      var skuMeta = '#product-sku-meta-' + selector.product.id.toString();
      var form;
      var radioButton;
      var i;

      if (variant) {
        form = $('#' + selector.domIdPrefix).closest('form');

        for (i = 0; i < variant.options.length; i += 1) {
          radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');

          if (radioButton.length) {
            radioButton.get(0).checked = true;
          }
        }
      }

      if (variant && variant.available) {
        if (variant.featured_image) {
          window.Shopify.Image.switchImage(variant.featured_image, $('#product-featured-image')[0], function(newImageSizedSrc) {
            $('#gallery-image img').each(function() {
              var grandSize = $(this).attr('src');

              if (grandSize && grandSize.indexOf('width=120') !== -1) {
                grandSize = grandSize.replace('width=120', 'width=1024');
              } else if (grandSize) {
                grandSize = grandSize.replace('120x', '1024x');
              }

              if (grandSize === newImageSizedSrc) {
                $(this).parent().trigger('click');
                return false;
              }
            });
          });
        }

        $(addToCart).removeClass('disabled').removeAttr('disabled').text(addToCartText);
        updateProductPrice(price, variant);

        $(priceMeta).attr('content', schemaPrice(variant.price));
        $(availabilityMeta).attr('content', 'https://schema.org/InStock');

        if (showSku) {
          if (variant.sku) {
            $('#sku').text(variant.sku).parent().removeClass('is-hidden').show();
            $(skuMeta).attr('content', variant.sku);
          } else {
            $('#sku').text('').parent().addClass('is-hidden').hide();
            $(skuMeta).attr('content', '');
          }
        }

        refreshCurrencies();
      } else {
        $(addToCart).addClass('disabled').attr('disabled', 'disabled');

        $(addToCart).text(variant ? soldOutText : unavailableText);
        updateProductPrice(price, variant, variant ? soldOutText : unavailableText);
        $(availabilityMeta).attr('content', 'https://schema.org/OutOfStock');

        if (showSku) {
          $('#sku').text('').parent().addClass('is-hidden').hide();
          $(skuMeta).attr('content', '');
        }
      }

      if (variant && variant.inventory_quantity && variant.inventory_management === 'shopify') {
        $('#stock').text(variant.inventory_quantity + ' ' + availableText).parent().show();
      } else {
        $('#stock').parent().hide();
      }
    }

    new window.Shopify.OptionSelectors('product-select-' + productId, {
      product: product,
      onVariantSelected: selectOptionsCallback,
      enableHistoryState: true
    });

    if (singleOptionLabel) {
      $('.selector-wrapper:eq(0)').prepend($('<label>').text(singleOptionLabel));
    }

    if (hideDefaultSelector) {
      $('.selector-wrapper').hide();
    }
  }

  $(window).on('load', function() {
    initQuantityButtons();
    $('[data-product-options-config]').each(function() {
      initProductOptions(this);
    });
  });
}(window, document, window.jQuery));
